import React, { useMemo } from 'react'
import st from './SettingsGoals.module.scss'
import ManagerRowSettings from '../ManagerRowSettings/ManagerRowSettings'

const groupEmployeesByBranch = (employees = [], branchOrder = []) => {
  const grouped = employees.reduce((acc, employee) => {
    const branchId = employee.branch?.id || 'no-branch'
    const branchName = employee.branch?.name || 'Без филиала'

    if (!acc[branchId]) {
      acc[branchId] = {
        branch: { id: branchId, name: branchName },
        employees: [],
      }
    }

    acc[branchId].employees.push({
      id: employee.id,
      name: employee.full_name,
      budget: employee.budget || '',
      deals: employee.deals || '',
      branch: employee.branch ?? null,
    })

    return acc
  }, {})

  const groupedArray = Object.values(grouped)

  return groupedArray.sort((a, b) => {
    const idxA = branchOrder.indexOf(a.branch.id)
    const idxB = branchOrder.indexOf(b.branch.id)

    if (idxA === -1 && idxB === -1) return 0
    if (idxA === -1) return 1
    if (idxB === -1) return -1

    return idxA - idxB
  })
}

const SettingsGoals = ({
  employees,
  setEmployees,
  disabled,
  translate,
  branchOrder,
}) => {
  const groupedData = useMemo(
    () => groupEmployeesByBranch(employees, branchOrder),
    [employees, branchOrder],
  )

  const branches = Object.values(groupedData)

  const totalBudgetTarget = branches.reduce(
    (sum, branch) =>
      sum +
      branch.employees.reduce(
        (branchSum, emp) => branchSum + (Number(emp.budget) || 0),
        0,
      ),
    0,
  )
  const totalDealsTarget = branches.reduce(
    (sum, branch) =>
      sum +
      branch.employees.reduce(
        (branchSum, emp) => branchSum + (Number(emp.deals) || 0),
        0,
      ),
    0,
  )

  const handleChange = (empId, changes) => {
    const updated = employees.map((emp) =>
      emp.id === empId ? { ...emp, ...changes } : emp,
    )
    setEmployees(updated)
  }

  return (
    <div className={st.container}>
      <div className={st.totalInf}>
        <div className={st.nameTxt}>{translate.total}</div>
        <div className={st.total}>
          <div className={st.containerTotal}>
            <div className={st.textBgt}>{translate.budget}:</div>
            <div className={st.textBgt}>{Number(totalBudgetTarget)}₸</div>
          </div>
          <div className={st.containerTotal}>
            <div className={st.textBgt}>{translate.quantity}:</div>
            <div className={st.textBgt}>{Number(totalDealsTarget)}</div>
          </div>
        </div>
      </div>
      <div className={st.container}>
        {branches.map((branchGroup) => {
          const { branch, employees } = branchGroup
          const branchTotalBudget = employees.reduce(
            (sum, emp) => sum + (Number(emp.budget) || 0),
            0,
          )
          const branchTotalQuantity = employees.reduce(
            (sum, emp) => sum + (Number(emp.deals) || 0),
            0,
          )
          return (
            <div key={branch.id} className={st.location}>
              <div className={st.containerSchool}>
                <div className={st.nameSt}>{branch.name}</div>
                <div className={st.containerInput}>
                  <div className={st.inputBox}>{branchTotalBudget}</div>
                  <div className={st.inputBox}>{branchTotalQuantity}</div>
                </div>
              </div>
              {employees.map((emp) => (
                <ManagerRowSettings
                  key={emp.id}
                  translate={translate}
                  manager={emp}
                  disabled={disabled}
                  onChange={(fields) => handleChange(emp.id, fields)}
                />
              ))}
              <div className={st.line}></div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default SettingsGoals
